import { defineComponent as _defineComponent } from 'vue'
import { RouterName, BoardCheckCode, BookRequiredType } from "@/types";
import { useServiceStore } from "@/stores/serviceStore";
import { computed } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useLineStore } from "@/stores/lineStore";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "NavigationBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    default: "",
  },
  shouldShowUnderline: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();



const isDev = process.env.NODE_ENV === "development";
const isStage = process.env.NODE_ENV === "stage";

const serviceStore = useServiceStore();
const userStore = useUserStore();
const lineStore = useLineStore();

const serviceInfo = computed(() => serviceStore.serviceInfo);
const userInfo = computed(() => userStore.userInfo);
const bookRequiredType = computed(() => lineStore.getBookRequiredType());

const __returned__ = { isDev, isStage, serviceStore, userStore, lineStore, serviceInfo, userInfo, bookRequiredType, get RouterName() { return RouterName }, get BoardCheckCode() { return BoardCheckCode }, get BookRequiredType() { return BookRequiredType }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})